// src/App.jsx
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Experience from "./pages/Experience";
import Travel from "./pages/Travel";
import Projects from "./pages/Projects";
import Media from "./pages/Media";
import Contribution from "./pages/Contribution";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";

function App() {
  return (
    <Router>
      {/* <MainLayout> */}
      <Navbar />
      <Routes>
        {/* Hero/Home */}
        <Route path="/" element={<Home />} />

        {/* Other Pages */}
        <Route path="/about" element={<About />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/travel" element={<Travel />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/media" element={<Media />} />
        <Route path="/contribution" element={<Contribution />} />
        <Route path="/contact" element={<Contact />} />

        {/* Optional: 404 Page */}
        <Route
          path="*"
          element={
            <h1 className="pt-32 text-center text-2xl text-red-400">
              404 – Page Not Found
            </h1>
          }
        />
      </Routes>
      {/* </MainLayout> */}
      <Footer />
    </Router>
  );
}

export default App;
